module.exports = __webpack_public_path__ + "static/media/noResult.f5ad7738.svg";